import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import logo from '../Assets/despar.jpg'
import { colors, bp } from '../theme'
import { getUser, clearAuth } from '../auth'

const Main = styled.nav`
  width: 100%;
  background: ${colors.white};
  border-bottom: 1px solid ${colors.line};
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`

const Container = styled.div`
  max-width: 1400px;
  margin: auto;
  height: 4.75rem;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${bp.mobile}) {
    padding: 0 1rem;
    height: 4.25rem;
  }
`

const LogoSection = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  text-decoration: none;
`

const LogoImg = styled.img`
  height: 42px;
  width: auto;
  object-fit: contain;
`

const Brand = styled.div`
  h2 {
    margin: 0;
    color: ${colors.green};
    font-size: 1rem;
    font-weight: 800;
  }
  span {
    color: ${colors.slate};
    font-size: 0.74rem;
  }

  @media (max-width: ${bp.mobile}) {
    h2 { font-size: 0.9rem; }
    span { font-size: 0.66rem; }
  }
`

const MenuButton = styled.button`
  display: none;
  border: none;
  background: transparent;
  color: ${colors.green};
  font-size: 1.7rem;
  cursor: pointer;

  @media (max-width: ${bp.tablet}) {
    display: block;
  }
`

const Links = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;

  @media (max-width: ${bp.tablet}) {
    position: absolute;
    top: 4.75rem;
    left: 0;
    width: 100%;
    background: ${colors.white};
    border-bottom: 1px solid ${colors.line};
    flex-direction: column;
    align-items: stretch;
    padding: ${({ open }) => (open ? '0.75rem 1rem' : '0 1rem')};
    max-height: ${({ open }) => (open ? '460px' : '0')};
    overflow: hidden;
    transition: all 0.3s ease;
  }
`

const Item = styled(Link)`
  text-decoration: none;
  color: ${({ $active }) => ($active ? colors.green : colors.ink)};
  background: ${({ $active }) => ($active ? colors.greenLight : 'transparent')};
  font-weight: 600;
  font-size: 0.93rem;
  padding: 0.55rem 0.9rem;
  border-radius: 8px;
  transition: 0.2s ease;

  &:hover {
    background: ${colors.greenLight};
    color: ${colors.green};
  }
`

const UserBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-left: 0.5rem;
  padding-left: 0.8rem;
  border-left: 1px solid ${colors.line};

  .who {
    text-align: right;
    line-height: 1.15;
  }
  .who strong {
    color: ${colors.ink};
    font-size: 0.88rem;
    display: block;
  }
  .who span {
    color: ${colors.slate};
    font-size: 0.72rem;
    text-transform: capitalize;
  }

  @media (max-width: ${bp.tablet}) {
    margin-left: 0;
    padding-left: 0;
    border-left: none;
    justify-content: space-between;
    border-top: 1px solid ${colors.line};
    padding-top: 0.75rem;
    margin-top: 0.25rem;
  }
`

const Logout = styled.button`
  background: ${colors.white};
  border: 1.5px solid ${colors.line};
  color: ${colors.red};
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.45rem 0.85rem;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    border-color: ${colors.red};
    background: ${colors.redLight};
  }
`

const items = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/devices', label: 'Devices' },
  { to: '/payments', label: 'Payments' },
  { to: '/users', label: 'Users' },
]

const Nav = () => {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const user = getUser()

  const logout = () => {
    clearAuth()
    navigate('/login', { replace: true })
  }

  return (
    <Main>
      <Container>
        <LogoSection to="/dashboard">
          <LogoImg src={logo} alt="Despar Clean logo" />
          <Brand>
            <h2>DESPAR CLEAN</h2>
            <span>Management Dashboard</span>
          </Brand>
        </LogoSection>

        <MenuButton onClick={() => setOpen(!open)} aria-label="Toggle menu">
          ☰
        </MenuButton>

        <Links open={open}>
          {items.map((it) => (
            <Item
              key={it.to}
              to={it.to}
              $active={location.pathname === it.to}
              onClick={() => setOpen(false)}
            >
              {it.label}
            </Item>
          ))}

          <UserBox>
            <div className="who">
              <strong>{user?.username || 'User'}</strong>
              <span>{user?.role || 'user'}</span>
            </div>
            <Logout onClick={logout}>Logout</Logout>
          </UserBox>
        </Links>
      </Container>
    </Main>
  )
}

export default Nav
